import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { Moment } from 'moment';
import React from 'react';
import CalendarPicker, { DisabledDatesFunc } from 'react-native-calendar-picker';
import Modal from 'react-native-modal';
import { Container, PrimaryButton, SwiperHeader } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { iconSize, metrics } from 'src/themes/Metrics';

interface Props {
  onConfirm(date: Date): void;
  onClose: () => void;
  isVisible: boolean;
  value: Date;
  button?: React.ReactElement;
  disabledDates?: Date[] | DisabledDatesFunc;
}

export const DatePicker = ({ value, onConfirm, onClose, isVisible, button, disabledDates }: Props) => {
  const onDateChange = (date: Moment) => {
    onConfirm(date.toDate());
  };

  // const handleDone = () => {
  //   if (date) {
  //     onConfirm(date);
  //   }
  // };

  return (
    <Modal
      animationIn="slideInUp"
      animationOut="slideOutDown"
      onSwipeComplete={onClose}
      onBackButtonPress={onClose}
      onBackdropPress={onClose}
      swipeThreshold={10}
      propagateSwipe
      style={{ margin: 0, justifyContent: 'flex-end' }}
      swipeDirection={['down']}
      isVisible={isVisible}>
      <Container
        style={{ borderTopEndRadius: metrics.borderRadius, borderTopLeftRadius: metrics.borderRadius }}
        paddingTop={metrics.medium}
        paddingBottom={metrics.large}
        backgroundColor="white">
        <SwiperHeader />
        <CalendarPicker
          previousComponent={<MaterialIcons size={iconSize.regular} name="keyboard-arrow-left" />}
          nextComponent={<MaterialIcons size={iconSize.regular} name="keyboard-arrow-right" />}
          selectedDayColor={AppColors.primary}
          selectedStartDate={value}
          selectedDayTextColor="white"
          onDateChange={onDateChange}
          disabledDates={disabledDates}
        />
        <Container padding={metrics.huge}>{button || <PrimaryButton text="close" onPress={onClose} />}</Container>
      </Container>
    </Modal>
  );
};
